/**
 * ダッシュボードのノードカードの並び。
 * 既定は名前順（Panel の API が名前順で返す）。利用者が並び替えたら、その順をこのブラウザに利用者ごとに残す。
 * 残した順にないノード（新しく足したノード）は、既定の順で後ろに付ける。
 */
const storageKey = (userId: string) => `mc-panel-node-order:${userId}`;

export function readNodeOrder(userId: string | undefined): string[] | undefined {
  if (!userId) return undefined;
  try {
    const saved = JSON.parse(localStorage.getItem(storageKey(userId)) ?? 'null') as unknown;
    return Array.isArray(saved) && saved.every((name) => typeof name === 'string') ? saved : undefined;
  } catch {
    return undefined;
  }
}

export function saveNodeOrder(userId: string | undefined, order: string[] | undefined): boolean {
  if (!userId) return false;
  try {
    if (order) localStorage.setItem(storageKey(userId), JSON.stringify(order));
    else localStorage.removeItem(storageKey(userId));
    return true;
  } catch {
    console.warn('ノードの並びを保存できません。この画面を開いている間だけ並びが変わります。');
    return false;
  }
}

/** order にある名前を先に、その順で。order にないものは元の順で後ろに */
export function applyNodeOrder<T extends { name: string }>(items: readonly T[], order: readonly string[] | undefined) {
  if (!order?.length) return [...items];
  const rank = new Map(order.map((name, index) => [name, index]));
  return items
    .map((item, index) => ({ item, index, rank: rank.get(item.name) ?? order.length + index }))
    .sort((a, b) => a.rank - b.rank)
    .map(({ item }) => item);
}

/** names の from 番目を to 番目へ動かした新しい並び */
export function moveName(names: readonly string[], from: number, to: number): string[] {
  const next = [...names];
  if (from < 0 || from >= next.length || to < 0 || to >= next.length || from === to) return next;
  const [moved] = next.splice(from, 1);
  next.splice(to, 0, moved as string);
  return next;
}
